module.exports = __webpack_public_path__ + "img/1_C.d34d5961.png";